import { render, staticRenderFns } from "./travel-insurance-policy.vue?vue&type=template&id=1c94ac40&scoped=true"
import script from "./travel-insurance-policy.vue?vue&type=script&setup=true&lang=ts"
export * from "./travel-insurance-policy.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./travel-insurance-policy.vue?vue&type=style&index=0&id=1c94ac40&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c94ac40",
  null
  
)

export default component.exports